import Uuid4 from 'uuid/v4'
import PubSub from 'pubsub-js'
import WreckAPI from './wreck_api.js'

class TokenStore {
  static tokenStorageKey() { return 'wreckfinderAPIToken' }

  static readToken() {
    const token = localStorage.getItem(this.tokenStorageKey())
    return token
  }

  static unstoreToken() {
    localStorage.removeItem(this.tokenStorageKey())
    return true
  }

  static storeToken(token) {
    localStorage.setItem(this.tokenStorageKey(), token)
    PubSub.publish('NEW_TOKEN_STORED', token);
    return token
  }

  static get() {
    const recentAPIToken = this.readToken()

    if (recentAPIToken && recentAPIToken.length > 0) {
      return new Promise((resolve, reject) => {
        resolve(recentAPIToken)
      })
    } else {
      const device_identifier = this.readOrGenerateUUID('wreckfinderDeviceIdentifier');
      const store_identifier = 'web';
      return WreckAPI.post('register_device.json', {}, {device_identifier, store_identifier})
        .then((json) => {
          const {bearer_token} = json
          return this.storeToken(bearer_token)
        })
        .catch((data) => {
          console.log(data)
          this.unstoreToken()
          alert(JSON.stringify(data.error))
        })
    }
  }

  static reset() {
    this.unstoreToken()
    return this.get()
  }

  static renew() {
    const recentAPIToken = this.readToken()

    if (recentAPIToken && recentAPIToken.length > 0) {
      return WreckAPI.get('new_token.json', {'Authorization': 'Bearer ' + recentAPIToken}, {})
        .then((json) => {
          const {bearer_token} = json
          return this.storeToken(bearer_token)
        })
        .catch((data) => {
          console.log(data)
          this.unstoreToken()
          alert(JSON.stringify(data.error))
        })
    } else {
      return this.get()
    }
  }

  static readOrGenerateUUID(storageKey) {
    const currentIdentifier = localStorage.getItem(storageKey);
    if (currentIdentifier) {
      return currentIdentifier;
    } else {
      const newIdentifier = Uuid4();
      localStorage.setItem(storageKey, newIdentifier);
      return newIdentifier;
    }
  }
}

export default TokenStore;



// WEBPACK FOOTER //
// ./src/lib/token_store.js